import React, { useImperativeHandle, forwardRef, useRef, useEffect } from 'react';

const AudioPlayer = forwardRef(({ onEnded }, ref) => {
  const audioRef = useRef(null);

  useImperativeHandle(ref, () => ({
    playVoice: (url) => {
      if (!audioRef.current) return;

      try {
        console.log("🎧 Attempting to play:", url);

        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current.src = url;

        audioRef.current.oncanplaythrough = () => {
          audioRef.current
            .play()
            .then(() => {
              console.log("✅ Voice playback started");
            })
            .catch(err => {
              console.warn("❌ Voice playback error:", err);
            });
        };

        audioRef.current.load();
      } catch (err) {
        console.warn("❌ Fatal error in playVoice:", err);
      }
    },
  }));

  useEffect(() => {
    const unlockAudio = () => {
      if (audioRef.current) {
        audioRef.current.play().catch(() => {});
      }
      document.removeEventListener('touchstart', unlockAudio);
      document.removeEventListener('click', unlockAudio);
    };

    document.addEventListener('touchstart', unlockAudio, { once: true });
    document.addEventListener('click', unlockAudio, { once: true });
  }, []);

  return (
    <audio
      ref={audioRef}
      onEnded={onEnded}
      style={{ display: 'none' }}
      crossOrigin="anonymous"
      playsInline
    />
  );
});

export default AudioPlayer;